"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _InputError = _interopRequireDefault(require("./InputError"));
var _reactTimePicker = _interopRequireDefault(require("react-time-picker"));
require("react-time-picker/dist/TimePicker.css");
require("react-clock/dist/Clock.css");
var _InputHelpText = _interopRequireDefault(require("./InputHelpText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const FormInputTime = props => {
  const onChangeTime = time => {
    props.onChange(time);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12 align-bottom col-sm-".concat(props.divColSize)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group row border-bottom pb-2"
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: props.name,
    className: (0, _classnames.default)("col-sm-12 m-0 pt-2 pb-2", {
      "is-invalid": props.error
    })
  }, props.label), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/_react.default.createElement(_reactTimePicker.default, {
    value: props.value,
    onChange: onChangeTime,
    format: "hh:mm a",
    className: (0, _classnames.default)(props.inputSizeClass, {
      "is-invalid": props.error
    })
  })), /*#__PURE__*/_react.default.createElement(_InputError.default, {
    error: props.error
  }), /*#__PURE__*/_react.default.createElement(_InputHelpText.default, {
    helpText: props.helpText
  }))));
};
var _default = FormInputTime;
exports.default = _default;